'use client';

import styled, { css, keyframes } from 'styled-components';

const marquee = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const marquee2 = keyframes`
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-200%);
  }
`;

export const StyledValuesBanner = styled.div`
  --duration: 40s;
  align-items: center;
  background-color: ${props => props.theme.colors.get(props.backgroundColor)};
  display: flex;
  height: 96px;
  overflow-x: hidden;
  width: 100%;
`;

export const ScrollContainer = styled.div`
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`;

export const MarqueeOne = styled.div`
  display: inline-block;
  white-space: nowrap;
  opacity: 0;
  transition: 250ms opacity;

  ${props =>
    props.$loaded &&
    css`
      animation: ${marquee} var(--duration) linear infinite;
      animation-delay: calc(var(--duration) / -2);
      opacity: 1;
    `}

  animation-play-state: ${props => (props.$paused ? 'paused' : 'running')};
`;

export const MarqueeTwo = styled.div`
  display: inline-block;
  white-space: nowrap;
  opacity: 0;
  transition: 250ms opacity;

  ${props =>
    props.$loaded &&
    css`
      animation: ${marquee2} var(--duration) linear infinite;
      opacity: 1;
    `}

  animation-play-state: ${props => (props.$paused ? 'paused' : 'running')};
`;

export const ValuesWrapper = styled.div`
  display: inline-block;
`;

export const ValueList = styled.div`
  display: flex;
`;

export const Value = styled.div`
  color: ${props => props.theme.colors.get(props.fontColor)};
  align-items: center;
  flex: 0 0 auto;
  display: flex;
  padding: 0 32px;
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  margin-right: 8px;
  height: 24px;
  width: 24px;

  img {
    display: block;
    height: 100%;
    object-fit: contain;
    width: 100%;
  }
`;

export const Text = styled.span`
  display: block;
  ${props => props.theme.fontFamily.base}
  font-size: 1rem;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.16px;
  white-space: nowrap;
`;
